import { StateType } from '../../../../states';
import { GRNotificationState } from '../../types/notification';
import { selectGRState } from '../gr/grPrimary.selector';

const emptyObj = {};
const emptyArray: Array<GRNotificationState> = [];

export const selectGRMiscState = (state: StateType) => selectGRState(state).misc ?? emptyObj;

export const selectGRMiscTmpNotifications = (state: StateType) =>
  selectGRMiscState(state).tmpNotifications ?? emptyArray;

export const selectGRMiscHomeVisitedIndex = (state: StateType) => selectGRMiscState(state).homeVisitedIndex ?? null;

export const selectGRMiscCurrentNotification = (state: StateType) => selectGRMiscTmpNotifications(state)[0] ?? emptyObj;
